import React from "react";
import SingleProject from "../components/SingleProject/SingleProject";

const ProjectPage = () => {
  return (
    <>
      <SingleProject />
    </>
  );
};

export default ProjectPage;
